import React, { useState } from 'react'
import PropTypes from 'prop-types'
import sortBy from 'lodash/sortBy'
import SimpleHeroCard from '../SimpleHeroCard/SimpleHeroCard'
import HeroLookupSortFilter from './HeroLookupSortFilter'

const HeroList = ({ heroes, onHeroSelected }) => {
    const [filters, setFilters] = useState({ mainClass: '', profession: '', rarity: '' })
    const [sort, setSort] = useState('id')

    // Update the selected filter criteria
    const handleFilterChange = ({ target }) => {
        setFilters(f => ({ ...f, [target.name]: target.value }))
    }

    // Update the selected sort criteria
    const handleSortChange = value => {
        setSort(value)
    }

    // Filter & Sort the heroes by the selected filter & sort criteria
    let heroesToDisplay = heroes.filter(hero => {
        const rarityFilter = !filters.rarity || Number(filters.rarity) === hero.rarity
        const mainClassFilter = !filters.mainClass || filters.mainClass.toLowerCase() === hero.mainClass.toLowerCase()
        const professionFilter =
            !filters.profession ||
            filters.profession === 'all' ||
            filters.profession.toLowerCase() === hero.profession.toLowerCase()

        return rarityFilter && mainClassFilter && professionFilter
    })

    heroesToDisplay = sortBy(heroesToDisplay, [sort])

    return heroes.length ? (
        <>
            {heroes.length > 3 && (
                <HeroLookupSortFilter values={filters} onFiltersChange={handleFilterChange} onSortChange={handleSortChange} />
            )}
            <div className="hero-lookup-list">
                {heroesToDisplay.map(hero => (
                    <div className="hero-lookup-item" key={hero.id} onClick={() => onHeroSelected(hero)}>
                        <SimpleHeroCard hero={hero} />
                    </div>
                ))}
            </div>
        </>
    ) : null
}

HeroList.propTypes = {
    heroes: PropTypes.array,
    onHeroSelected: PropTypes.func,
}

HeroList.defaultProps = {
    heroes: [],
    onHeroSelected: () => {},
}

export default HeroList
